(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hf-product-hero"] && !Shopify.designMode) return;
  try {
    (function () {
      function initProduct(root) {
        if (!root || root.dataset.hfInitialized === 'true') {
          return;
        }
        root.dataset.hfInitialized = 'true';
        var sectionId = root.dataset.sectionId;
        /* ==========================================
       ELEMENTS
    ========================================== */
        var variantDataEl = root.querySelector('.hf-variant-data');
        var variants = [];
        if (variantDataEl) {
          try {
            variants = JSON.parse(variantDataEl.textContent);
          } catch (error) {
            console.error('HF Product: Variant JSON error', error);
          }
        }
        var hiddenIdInput = root.querySelector('#hf-variant-id-' + sectionId);
        var addToCartBtn = root.querySelector('.hf-add-to-cart');
        var addToCartLabel = root.querySelector('.hf-add-to-cart__label');
        var actualPriceEl = root.querySelector('.hf-actual-price');
        var comparePriceEl = root.querySelector('.price-variant .hf-price--compare');
        var moneyFormat = root.dataset.moneyFormat || '${{amount}}';
        /* ==========================================
       SELECTED OPTIONS
    ========================================== */
        var selectedOptions = {};
        root.querySelectorAll('.hf-swatch.is-selected, .hf-pill.is-selected').forEach(function (el) {
          selectedOptions[el.dataset.optionIndex] = el.dataset.value;
        });
        /* ==========================================
       FORMAT MONEY
    ========================================== */
        function formatMoney(cents) {
          if (cents === null || cents === undefined) {
            return '';
          }
          var amount = Number(cents);
          if (isNaN(amount)) {
            return '';
          }
          var formatted = (amount / 100).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');

          /*
           * Handle {{ amount }}
           */
          if (moneyFormat.indexOf('{{amount}}') !== -1) {
            return moneyFormat.replace(/\{\{\s*amount\s*\}\}/, formatted);
          }
          return '$' + formatted;
        }
        /* ==========================================
       FIND MATCHING VARIANT
    ========================================== */
        function findMatchingVariant() {
          if (!variants.length) {
            return null;
          }
          return variants.find(function (variant) {
            var optionKeys = ['option1', 'option2', 'option3'];
            return Object.keys(selectedOptions).every(function (position) {
              var index = parseInt(position, 10) - 1;
              var optionKey = optionKeys[index];
              if (!optionKey) {
                return true;
              }
              return variant[optionKey] === selectedOptions[position];
            });
          });
        }

        /* ==========================================
       UPDATE PRICE
    ========================================== */
        var KACHING_PRICE_SELECTORS = ['.kaching-bundles__bar-price'];
var KACHING_COMPARE_SELECTORS = ['.kaching-bundles__bar-full-price', 's', 'del'];

function queryFirst(parent, selectors) {
  for (var i = 0; i < selectors.length; i++) {
    var el = parent.querySelector(selectors[i]);
    if (el && el.textContent.trim() !== '') return el;
  }
  return null;
}

function getKachingPrices() {
  var block = document.querySelector('.kaching-bundles__block');
  if (!block) return null;
  var checked = block.querySelector('input[type="radio"]:checked');
  var bar = checked ? checked.closest('.kaching-bundles__bar') : null;
  if (!bar) return null;
  var priceEl = queryFirst(bar, KACHING_PRICE_SELECTORS);
  if (!priceEl) return null;
  var compareEl = queryFirst(bar, KACHING_COMPARE_SELECTORS);
  return {
    price: priceEl.textContent.trim(),
    compare: compareEl ? compareEl.textContent.trim() : '',
  };
}

function setButtonPrices(priceText, compareText) {
  if (actualPriceEl) actualPriceEl.textContent = priceText;
  if (comparePriceEl) {
    if (compareText && compareText !== priceText) {
      comparePriceEl.textContent = compareText;
      comparePriceEl.style.display = '';
    } else {
      comparePriceEl.textContent = '';
      comparePriceEl.style.display = 'none';
    }
  }
}

function updatePrice(variant) {
  var kaching = getKachingPrices();
  if (kaching) {
    setButtonPrices(kaching.price, kaching.compare);
    return;
  }
  if (!variant) return;
  var compare =
    variant.compare_at_price && variant.compare_at_price > variant.price
      ? formatMoney(variant.compare_at_price)
      : '';
  setButtonPrices(formatMoney(variant.price), compare);
}

function initKachingPriceSync() {
  var observedBlock = null;
  var frame = null;

  function sync() {
    if (frame) cancelAnimationFrame(frame);
    frame = requestAnimationFrame(function () {
      updatePrice(findMatchingVariant());
    });
  }

  function attach() {
    var block = document.querySelector('.kaching-bundles__block');
    if (!block) return false;
    if (block === observedBlock) return true;
    observedBlock = block;
    block.addEventListener('change', sync);
    block.addEventListener('click', function () { setTimeout(sync, 50); });
    new MutationObserver(sync).observe(block, {
      subtree: true, childList: true, characterData: true,
      attributes: true, attributeFilter: ['class', 'checked'],
    });
    sync();
    return true;
  }

  if (!attach()) {
    var waitObserver = new MutationObserver(function () {
      if (attach()) waitObserver.disconnect();
    });
    waitObserver.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { waitObserver.disconnect(); }, 15000);
  }
}

        /* ==========================================
       UPDATE ADD TO CART BUTTON
    ========================================== */
        function updateAddToCartButton(variant) {
          if (!addToCartBtn || !variant) {
            return;
          }
          if (variant.available) {
            addToCartBtn.disabled = false;
            addToCartBtn.classList.remove('is-sold-out');
            if (addToCartLabel) {
              addToCartLabel.textContent = 'Add to Cart';
            }
          } else {
            addToCartBtn.disabled = true;
            addToCartBtn.classList.add('is-sold-out');
            if (addToCartLabel) {
              addToCartLabel.textContent = 'Sold Out';
            }
          }
        }
        /* ==========================================
       APPLY VARIANT
    ========================================== */
        function applyVariant(variant) {
          if (!variant) {
            return;
          }

          if (hiddenIdInput) {
            hiddenIdInput.value = variant.id;
          }
          updatePrice(variant);
          updateAddToCartButton(variant);
        }
        /* ==========================================
       UPDATE SELECTED OPTION TEXT
    ========================================== */

        function updateSelectedOptionText(optionName, value) {
          var target = root.querySelector(
            '.hf-selected-option[data-option-name="' + optionName + '"] .hf-selected-option__value'
          );
          if (target) {
            target.textContent = value;
          }
        }
        /* ==========================================
 EXTRACT COLOR FROM ALT TEXT
========================================== */
        function extractColorFromAlt(altText) {
          if (!altText) {
            return '';
          }
          var match = altText.match(/-\s*(?:en_)?([^\]]*)\]/i);
          if (!match) {
            return '';
          }
          return match[1].replace(/^en_/i, '').trim().toLowerCase();
        }
        /* ==========================================
 FILTER GALLERY BY COLOR
========================================== */
        function filterGallery(color) {
          color = (color || '').toLowerCase().trim();
          var firstSlide = null;
          var firstThumb = null;
          root.querySelectorAll('.hf-gallery__slide').forEach(function (slide) {
            var slideColor = extractColorFromAlt(slide.dataset.alt);
            var matches = slideColor === '' || slideColor === color;
            slide.classList.toggle('hf-gallery__slide--hidden', !matches);
            slide.classList.remove('is-active');
            if (matches && !firstSlide) {
              firstSlide = slide;
            }
            var dot = root.querySelector('.hf-gallery__dot[data-media-id="' + slide.dataset.mediaId + '"]');
            if (dot) {
              dot.classList.toggle('hf-gallery__dot--hidden', !matches);
            }
          });
          root.querySelectorAll('.hf-thumb').forEach(function (thumb) {
            var thumbColor = extractColorFromAlt(thumb.dataset.alt);
            var matches = thumbColor === '' || thumbColor === color;
            thumb.classList.toggle('hf-thumb--hidden', !matches);
            thumb.classList.remove('is-active');
            if (matches && !firstThumb) {
              firstThumb = thumb;
            }
          });
          if (firstSlide) {
            firstSlide.classList.add('is-active');
          }
          if (firstThumb) {
            firstThumb.classList.add('is-active');
          }
          if (!firstSlide) {
            var fallbackSlide = root.querySelector('.hf-gallery__slide');
            if (fallbackSlide) {
              fallbackSlide.classList.remove('hf-gallery__slide--hidden');
              fallbackSlide.classList.add('is-active');
              firstSlide = fallbackSlide;
              var fallbackDot = root.querySelector(
                '.hf-gallery__dot[data-media-id="' + fallbackSlide.dataset.mediaId + '"]'
              );
              if (fallbackDot) {
                fallbackDot.classList.remove('hf-gallery__dot--hidden');
              }
            }
          }
          if (!firstThumb) {
            var fallbackThumb = root.querySelector('.hf-thumb');
            if (fallbackThumb) {
              fallbackThumb.classList.remove('hf-thumb--hidden');
              fallbackThumb.classList.add('is-active');
            }
          }
          if (firstSlide) {
            setActiveSlideState(firstSlide.dataset.mediaId);
            if (typeof goToSlideId === 'function') {
              goToSlideId(firstSlide.dataset.mediaId, true);
            }
          }
        }
        var galleryMain = root.querySelector('.hf-gallery__main');
        var galleryTrack = root.querySelector('.hf-gallery__track');
        var galleryDots = root.querySelectorAll('.hf-gallery__dot');
        function getVisibleSlides() {
          return Array.prototype.filter.call(root.querySelectorAll('.hf-gallery__slide'), function (slide) {
            return !slide.classList.contains('hf-gallery__slide--hidden');
          });
        }
        function setActiveDot(mediaId) {
          galleryDots.forEach(function (dot) {
            dot.classList.toggle('is-active', dot.dataset.mediaId === String(mediaId));
          });
        }
        function setActiveThumb(mediaId) {
          root.querySelectorAll('.hf-thumb').forEach(function (thumb) {
            thumb.classList.toggle('is-active', thumb.dataset.mediaId === String(mediaId));
          });
        }
        function setActiveSlideState(mediaId) {
          root.querySelectorAll('.hf-gallery__slide').forEach(function (slide) {
            slide.classList.toggle('is-active', slide.dataset.mediaId === String(mediaId));
          });
          setActiveDot(mediaId);
          setActiveThumb(mediaId);
        }
        var dragState = {
          active: false,
          locked: null, // 'x' once a horizontal drag is confirmed, 'y' to bail out
          startX: 0,
          startY: 0,
          containerWidth: 0,
          index: 0,
        };
        function currentSlideIndex() {
          var visible = getVisibleSlides();
          var activeSlide = root.querySelector('.hf-gallery__slide.is-active');
          var index = visible.indexOf(activeSlide);
          return index === -1 ? 0 : index;
        }
        function goToIndex(index, instant) {
          if (!galleryTrack) {
            return;
          }
          var visible = getVisibleSlides();
          if (!visible.length) {
            return;
          }
          index = Math.max(0, Math.min(index, visible.length - 1));
          var slide = visible[index];
          if (window.innerWidth <= 767) {
            galleryTrack.classList.toggle('hf-gallery__track--instant', Boolean(instant));
            galleryTrack.style.transform = 'translateX(-' + index * 100 + '%)';
          } else {
            galleryTrack.classList.remove('hf-gallery__track--instant');
            galleryTrack.style.transform = '';
          }
          dragState.index = index;
          if (slide) {
            setActiveSlideState(slide.dataset.mediaId);
          }
        }
        function goToSlideId(mediaId, instant) {
          var visible = getVisibleSlides();
          var index = visible.findIndex(function (slide) {
            return slide.dataset.mediaId === String(mediaId);
          });
          goToIndex(index === -1 ? 0 : index, instant);
        }
        galleryDots.forEach(function (dot) {
          dot.addEventListener('click', function () {
            goToSlideId(dot.dataset.mediaId, false);
          });
        });
        if (galleryMain && galleryTrack) {
          galleryMain.addEventListener('pointerdown', function (event) {
            if (window.innerWidth > 767) {
              return;
            }
            dragState.active = true;
            dragState.locked = null;
            dragState.startX = event.clientX;
            dragState.startY = event.clientY;
            dragState.containerWidth = galleryMain.getBoundingClientRect().width || 1;
            dragState.index = currentSlideIndex();
            galleryTrack.classList.add('hf-gallery__track--instant');
          });
          galleryMain.addEventListener('pointermove', function (event) {
            if (!dragState.active) {
              return;
            }
            var deltaX = event.clientX - dragState.startX;
            var deltaY = event.clientY - dragState.startY;
            if (!dragState.locked) {
              if (Math.abs(deltaX) < 6 && Math.abs(deltaY) < 6) {
                return;
              }
              dragState.locked = Math.abs(deltaX) > Math.abs(deltaY) ? 'x' : 'y';
              if (dragState.locked === 'y') {
                dragState.active = false;
                galleryTrack.classList.remove('hf-gallery__track--instant');
                return;
              }
            }
            event.preventDefault();
            var basePercent = -dragState.index * 100;
            var deltaPercent = (deltaX / dragState.containerWidth) * 100;
            galleryTrack.style.transform = 'translateX(' + (basePercent + deltaPercent) + '%)';
          });
          function endDrag(event) {
            if (!dragState.active) {
              return;
            }
            dragState.active = false;
            galleryTrack.classList.remove('hf-gallery__track--instant');
            if (dragState.locked !== 'x') {
              goToIndex(dragState.index, false);
              return;
            }
            var deltaX = event.clientX - dragState.startX;
            var threshold = dragState.containerWidth * 0.18;
            var visible = getVisibleSlides();
            var nextIndex = dragState.index;
            if (deltaX <= -threshold && dragState.index < visible.length - 1) {
              nextIndex = dragState.index + 1;
            } else if (deltaX >= threshold && dragState.index > 0) {
              nextIndex = dragState.index - 1;
            }
            goToIndex(nextIndex, false);
          }
          galleryMain.addEventListener('pointerup', endDrag);
          galleryMain.addEventListener('pointercancel', endDrag);
          galleryMain.addEventListener('pointerleave', function (event) {
            if (dragState.active) {
              endDrag(event);
            }
          });
          goToIndex(currentSlideIndex(), true);
        }
        window.addEventListener('resize', function () {
          if (galleryTrack) {
            goToIndex(dragState.index || currentSlideIndex(), true);
          }
        });

        /* ==========================================
       FILTER SIZE BY GENDER
    ========================================== */
        function filterSizesByGender(genderValue) {
          var sizeWrapper = root.querySelector('.hf-option--size');
          if (!sizeWrapper || !genderValue) {
            return;
          }
          var gender = genderValue.toLowerCase().trim();
          var prefix = '';
          if (gender === 'women' || gender === 'woman') {
            prefix = 'W ';
          } else if (gender === 'men' || gender === 'man') {
            prefix = 'M ';
          } else {
            prefix = genderValue.charAt(0).toUpperCase() + ' ';
          }
          var visiblePills = [];
          sizeWrapper.querySelectorAll('.hf-pill').forEach(function (pill) {
            var value = pill.dataset.value || '';
            if (value.indexOf(prefix) === 0) {
              pill.style.display = '';
              visiblePills.push(pill);
            } else {
              pill.style.display = 'none';
              if (pill.classList.contains('is-selected')) {
                pill.classList.remove('is-selected');
                delete selectedOptions[pill.dataset.optionIndex];
              }
            }
          });

          var alreadySelected = visiblePills.some(function (pill) {
            return pill.classList.contains('is-selected');
          });
          if (!alreadySelected && visiblePills.length) {
            var firstPill = visiblePills[0];
            firstPill.classList.add('is-selected');
            selectedOptions[firstPill.dataset.optionIndex] = firstPill.dataset.value;
            updateSelectedOptionText('Size', firstPill.dataset.value);
          }
        }
        /* ==========================================
       OPTION CLICK
    ========================================== */
        root.querySelectorAll('.hf-swatch, .hf-pill').forEach(function (el) {
          el.addEventListener('click', function () {
            var group = el.closest('.hf-option__values');
            var optionWrapper = el.closest('.hf-option');
            var optionName = optionWrapper ? optionWrapper.dataset.optionName : null;
            if (group) {
              group.querySelectorAll('.hf-swatch, .hf-pill').forEach(function (item) {
                item.classList.remove('is-selected');
              });
            }
            el.classList.add('is-selected');
            selectedOptions[el.dataset.optionIndex] = el.dataset.value;
            if (optionName) {
              updateSelectedOptionText(optionName, el.dataset.value);
            }
            if (optionName === 'Gender') {
              filterSizesByGender(el.dataset.value);
            }
            var matchedVariant = findMatchingVariant();
            if (matchedVariant) {
              applyVariant(matchedVariant);
            }
            if (el.dataset.color) {
              filterGallery(el.dataset.color);
            }
          });
        });
        /* ==========================================
       THUMBNAIL CLICK
    ========================================= */
        root.querySelectorAll('.hf-thumb').forEach(function (thumb) {
          thumb.addEventListener('click', function () {
            var id = thumb.dataset.mediaId;
            setActiveSlideState(id);
            goToSlideId(id, false);
          });
        });
        /* ==========================================
       SELL OUT RISK
    ========================================== */
        var selloutRisk = root.querySelector('.hf-sellout-risk');
        var selloutToggle = root.querySelector('.hf-sellout-risk__toggle');
        if (selloutRisk && selloutToggle) {
          selloutToggle.addEventListener('click', function () {
            var isOpen = selloutRisk.classList.toggle('is-open');
            selloutToggle.setAttribute('aria-expanded', String(isOpen));
          });
        }
        /* ==========================================
       SIZE & FIT CHART MODAL
    ========================================== */
        root.querySelectorAll('[data-size-chart-target]').forEach(function (trigger) {
          trigger.addEventListener('click', function () {
            var modal = document.getElementById(trigger.dataset.sizeChartTarget);
            if (modal && typeof modal.showModal === 'function') {
              modal.showModal();
            }
          });
        });
        root.querySelectorAll('.hf-size-chart-modal').forEach(function (modal) {
          var closeBtn = modal.querySelector('.hf-size-chart-modal__close');
          if (closeBtn) {
            closeBtn.addEventListener('click', function () {
              modal.close();
            });
          }
          modal.addEventListener('click', function (event) {
            if (event.target === modal) {
              modal.close();
            }
          });
        });
        /* ==========================================
   REVIEW MODAL (desktop custom popup)
========================================== */
        function openReviewModal(modal, trigger) {
          var rect = trigger.getBoundingClientRect();
          var modalWidth = 340;
          var left = rect.left + window.scrollX;
          var maxLeft = window.scrollX + document.documentElement.clientWidth - modalWidth - 12;
          if (left > maxLeft) left = Math.max(window.scrollX + 12, maxLeft);
          modal.style.top = rect.bottom + window.scrollY + 12 + 'px';
          modal.style.left = left + 'px';
          var arrowOffset = rect.left + window.scrollX - left + rect.width / 2 - 8;
          modal.style.setProperty('--rm-arrow-left', arrowOffset + 'px');
          modal.classList.add('is-open');
          document.body.classList.add('hf-review-modal-lock');

          // Close the modal as soon as the user scrolls anywhere (page or inner containers)
          if (!modal._rmScrollHandler) {
            modal._rmScrollHandler = function () {
              closeReviewModal(modal);
            };
          }
          window.addEventListener('scroll', modal._rmScrollHandler, { passive: true, capture: true });
        }

        function closeReviewModal(modal) {
          modal.classList.remove('is-open');
          document.body.classList.remove('hf-review-modal-lock');

          if (modal._rmScrollHandler) {
            window.removeEventListener('scroll', modal._rmScrollHandler, { capture: true });
          }
        }

        root.querySelectorAll('[data-review-modal-target]').forEach(function (trigger) {
          trigger.addEventListener(
            'click',
            function (event) {
              event.preventDefault();
              event.stopPropagation();
              var modal = document.getElementById(trigger.dataset.reviewModalTarget);
              if (!modal) return;
              openReviewModal(modal, trigger);
            },
            true
          );
        });
        root.querySelectorAll('.hf-review-modal').forEach(function (modal) {
          var closeBtn = modal.querySelector('.hf-review-modal__close');
          if (closeBtn) {
            closeBtn.addEventListener('click', function () {
              closeReviewModal(modal);
            });
          }
        });
        function handleOutsideInteraction(event) {
          root.querySelectorAll('.hf-review-modal.is-open').forEach(function (modal) {
            var trigger = root.querySelector('[data-review-modal-target="' + modal.id + '"]');
            if (!modal.contains(event.target) && event.target !== trigger && !trigger.contains(event.target)) {
              closeReviewModal(modal);
            }
          });
        }
        document.addEventListener('click', handleOutsideInteraction);
        document.addEventListener('touchstart', handleOutsideInteraction, { passive: true });
        /* REVIEW MODAL CAROUSEL (first 3 reviews) */
        root.querySelectorAll('[data-rm-carousel]').forEach(function (carousel) {
          var cards = carousel.querySelectorAll('.rm-card');
          var dotsWrap = carousel.parentElement.querySelector('[data-rm-dots]');
          var dots = dotsWrap ? dotsWrap.querySelectorAll('.rm-dot') : [];
          var prevBtn = carousel.parentElement.querySelector('[data-rm-prev]');
          var nextBtn = carousel.parentElement.querySelector('[data-rm-next]');
          var current = 0;
          function show(i) {
            current = (i + cards.length) % cards.length;
            cards.forEach(function (c, idx) {
              c.hidden = idx !== current;
            });
            dots.forEach(function (d, idx) {
              d.classList.toggle('is-active', idx === current);
            });
          }
          if (prevBtn)
            prevBtn.addEventListener('click', function () {
              show(current - 1);
            });
          if (nextBtn)
            nextBtn.addEventListener('click', function () {
              show(current + 1);
            });
          dots.forEach(function (d) {
            d.addEventListener('click', function () {
              show(parseInt(d.dataset.i));
            });
          });
        });
        /* ==========================================
       REFRESH CART DRAWER
    ========================================== */
        async function refreshCartDrawer() {
          try {
            var response = await fetch(window.Shopify.routes.root + '?sections=cart-drawer-section', {
              headers: {
                Accept: 'application/json',
              },
            });
            if (!response.ok) {
              return;
            }
            var sections = await response.json();
            var cartDrawerHtml = sections['cart-drawer-section'];
            if (!cartDrawerHtml) {
              return;
            }
            var parser = new DOMParser();
            var doc = parser.parseFromString(cartDrawerHtml, 'text/html');
            var newDrawer = doc.querySelector('#cart-drawer');
            var currentDrawer = document.querySelector('#cart-drawer');
            if (newDrawer && currentDrawer) {
              currentDrawer.innerHTML = newDrawer.innerHTML;
            }
          } catch (error) {
            console.error('HF Product: Cart drawer refresh failed', error);
          }
        }
        /* ==========================================
       OPEN CART DRAWER
    ========================================== */
        function openCartDrawer() {
          var cartDrawer = document.querySelector('#cart-drawer');
          if (cartDrawer && typeof cartDrawer.open === 'function') {
            cartDrawer.open();
          }
        }
        /* ==========================================
       BUILD OPTION NAME -> POSITION MAP
    ========================================== */
        var optionNameToPosition = {};
        root.querySelectorAll('.hf-option[data-option-name]').forEach(function (el) {
          optionNameToPosition[el.dataset.optionName] = el.dataset.optionPosition;
        });
        /* ==========================================
       FIND VARIANT BY {Colour, Gender, Size}
    ========================================== */
        function findVariantByNamedOptions(namedOptions) {
          if (!variants.length) {
            return null;
          }
          var optionKeys = ['option1', 'option2', 'option3'];
          return variants.find(function (variant) {
            return Object.keys(namedOptions).every(function (name) {
              var position = optionNameToPosition[name];
              if (!position) {
                return true;
              }
              var key = optionKeys[parseInt(position, 10) - 1];
              if (!key) {
                return true;
              }
              return variant[key] === namedOptions[name];
            });
          });
        }
        /* ==========================================
       READ SELECTED KACHING BUNDLE ROWS
    ========================================== */
        function getKachingBundleItems() {
          var block = document.querySelector('.kaching-bundles__block');
          if (!block) {
            return null;
          }
          var checkedRadio = block.querySelector('input[type="radio"]:checked');
          if (!checkedRadio) {
            return null;
          }
          var selectedBar = checkedRadio.closest('.kaching-bundles__bar');
          if (!selectedBar) {
            return null;
          }
          var titleEl = selectedBar.querySelector('.kaching-bundles__bar-title');
          var pairCount = 1;
          if (titleEl) {
            var match = titleEl.textContent.match(/\d+/);
            if (match) {
              pairCount = parseInt(match[0], 10);
            }
          }
          var items = [];
          var variantGroups = selectedBar.querySelectorAll('.kaching-bundles__bar-variant-selects');
          variantGroups.forEach(function (group) {
            var namedOptions = {};
            group.querySelectorAll('select[data-name]').forEach(function (select) {
              namedOptions[select.dataset.name] = select.value;
            });
            var matchedVariant = findVariantByNamedOptions(namedOptions);
            if (matchedVariant) {
              items.push({ id: matchedVariant.id, quantity: 1 });
            }
          });
          var remaining = pairCount - items.length;
          if (remaining > 0) {
            var mainVariant = findMatchingVariant();
            if (mainVariant) {
              items.push({ id: mainVariant.id, quantity: remaining });
            }
          }
          return items.length ? items : null;
        }
        /* ==========================================
       ADD TO CART
    ========================================== */
        if (addToCartBtn) {
          addToCartBtn.addEventListener('click', function (event) {
            event.preventDefault();
            var currentVariant = findMatchingVariant();
            if (currentVariant && hiddenIdInput) {
              hiddenIdInput.value = currentVariant.id;
            }
            if (currentVariant && !currentVariant.available) {
              return;
            }
            addToCartBtn.disabled = true;
            if (addToCartLabel) {
              addToCartLabel.textContent = 'Adding...';
            }
            var kachingItems = getKachingBundleItems();
            var payload = kachingItems ? { items: kachingItems } : { items: [{ id: currentVariant.id, quantity: 1 }] };
            fetch(window.Shopify.routes.root + 'cart/add.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
              },
              body: JSON.stringify(payload),
            })
              .then(function (response) {
                if (!response.ok) {
                  return response.json().then(function (err) {
                    throw new Error(err.description || 'Unable to add product to cart.');
                  });
                }
                return response.json();
              })
              .then(function () {
                return refreshCartDrawer();
              })
              .then(function () {
                openCartDrawer();
                document.dispatchEvent(new CustomEvent('cart:updated', {}));
                document.dispatchEvent(new CustomEvent('cart:refresh', {}));
              })
              .catch(function (error) {
                console.error('HF Product: Add to cart failed', error);
                alert(error.message || 'Something went wrong while adding the product.');
              })
              .finally(function () {
                var latestVariant = findMatchingVariant();
                addToCartBtn.disabled = latestVariant ? !latestVariant.available : false;
                if (addToCartLabel) {
                  addToCartLabel.textContent = latestVariant && !latestVariant.available ? 'Sold Out' : 'Add to Cart';
                }
              });
          });
        }
        /*  INITIAL GALLERY */
        var defaultColor = root.querySelector('.hf-swatch.is-selected');
        if (defaultColor) {
          filterGallery(defaultColor.dataset.color);
        }
        /* INITIAL GENDER / SIZE */
        var defaultGenderPill = root.querySelector('.hf-option--gender .hf-pill.is-selected');
        if (defaultGenderPill) {
          filterSizesByGender(defaultGenderPill.dataset.value);
        }
        /*  INITIAL VARIANT */
        var initialVariant = findMatchingVariant();
if (initialVariant) {
  applyVariant(initialVariant);
}
initKachingPriceSync();
        /* ==========================================
       OFFER COUNTDOWN TIMER
    ========================================== */
        var offerTimerEl = root.querySelector('[data-offer-timer]');
        if (offerTimerEl) {
          var offerTimerValueEl = offerTimerEl.querySelector('[data-offer-timer-value]');
          var durationMinutes = parseFloat(offerTimerEl.dataset.durationMinutes) || 0;
          var storageKey = 'hf-offer-timer-end-' + sectionId;
          var endTime = parseInt(sessionStorage.getItem(storageKey), 10);

          if (!endTime || endTime < Date.now()) {
            endTime = Date.now() + durationMinutes * 60 * 1000;
            sessionStorage.setItem(storageKey, String(endTime));
          }

          function updateOfferTimer() {
            var remaining = Math.max(0, endTime - Date.now());
            var totalSeconds = Math.floor(remaining / 1000);
            var minutes = Math.floor(totalSeconds / 60);
            var seconds = totalSeconds % 60;
            var formatted = String(minutes).padStart(2, '0') + ':' + String(seconds).padStart(2, '0');
            if (offerTimerValueEl) {
              offerTimerValueEl.textContent = formatted;
            }
            if (remaining <= 0) {
              clearInterval(offerTimerInterval);
            }
          }

          updateOfferTimer();
          var offerTimerInterval = setInterval(updateOfferTimer, 1000);
        }

        /* VIEW ALL -> scroll to Loox Reviews Widget section */
        function scrollToLooxWidget() {
          var reviewsTarget = document.getElementById('looxReviews');
          if (reviewsTarget) {
            reviewsTarget.scrollIntoView({ behavior: 'smooth', block: 'start' });
          } else {
            console.warn('HF Product: #looxReviews element not found on this page.');
          }
        }
        root.querySelectorAll('[data-rm-view-all]').forEach(function (btn) {
          btn.addEventListener('click', function () {
            var modal = btn.closest('.hf-review-modal');
            if (modal) {
              closeReviewModal(modal);
            }
            setTimeout(scrollToLooxWidget, 150);
          });
        });
      }
      /* INITIALIZE PRODUCTS */
      document.querySelectorAll('.hf-product').forEach(function (root) {
        initProduct(root);
      });
      /* ==========================================
     SHOPIFY THEME EDITOR SECTION RELOAD SUPPORT
  ========================================== */
      document.addEventListener('shopify:section:load', function (event) {
        if (!event.target) {
          return;
        }
        event.target.querySelectorAll('.hf-product').forEach(function (root) {
          initProduct(root);
        });
      });
    })();
  } catch(e) { console.error(e); }
})();

})();
